import { SimsoService } from 'src/services/simso.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const SIMSO_NEW_CARE_SUCCESS = 'SIMSO:NEW_CARE_SUCCESS'
export const SIMSO_LIST_SUCCESS = 'SIMSO:FIND_ALL_SUCCESS'
export const SIMSO_LIST_FAILD = 'SIMSO:FIND_ALL_FAILD'
export const SIMSO_COUNT_ASSIGN_SUCCESS = 'SIMSO:COUNT_ASSIGN_SUCCESS'
export const SIMSO_COUNT_ASSIGN_FAILD = 'SIMSO:COUNT_ASSIGN_FAILD'

export const SIMSO_CREATE_SUCCESS = 'SIMSO:CREATE_SUCCESS'
export const SIMSO_CREATE_FAILD = 'SIMSO:CREATE_FAILD'

export const SIMSO_IMPORT_SUCCESS = 'SIMSO:IMPORT_SUCCESS'
export const SIMSO_SAVE_SUCCESS = 'SIMSO:SAVE_SUCCESS'
export const SIMSO_SAVE_FAILD = 'SIMSO:SAVE_SUCCESS'

export const SIMSO_DEL_SUCCESS = 'SIMSO:DEL_SUCCESS'
export const SIMSO_DEL_FAILD = 'SIMSO:DEL_FAILD'

export const SIMSO_ONE_SUCCESS = 'SIMSO:FIND_ONE_SUCCESS'
export const SIMSO_ONE_FAILD = 'SIMSO:FIND_ONE_FAILD'

export const SIMSO_HISTORY_LIST_SUCCESS = 'SIMSO:HISTORY_FIND_ALL_SUCCESS'
export const SIMSO_HISTORY_LIST_FAILD = 'SIMSO:HISTORY_FIND_ALL_FAILD'

export const SIMSO_UPDATE_FILTER = 'SIMSO:SIMSO_UPDATE_FILTER'

export const SIMSO_LIST_EXPORT_SUCCESS = 'SIMSO:FIND_ALL_EXPORT_SUCCESS'
export const SIMSO_LIST_EXPORT_FAILD = 'SIMSO:FIND_ALL_EXPORT_FAILD'

export const SIMSO_UPDATE_HOMEPAGE_FILTER = 'SIMSO:SIMSO_UPDATE_HOMEPAGE_FILTER'

export const SIMSO_HOMEPAGE_LIST_SUCCESS = 'SIMSO:FIND_HOMEPAGE_LIST_SUCCESS'
export const SIMSO_HOMEPAGE_LIST_FAILD = 'SIMSO:FIND_HOMEPAGE_LIST_FAILD'

export const SIMSO_HOMEPAGE_ONE_SUCCESS = 'SIMSO:FIND_HOMEPAGE_ONE_SUCCESS'
export const SIMSO_HOMEPAGE_ONE_FAILD = 'SIMSO:FIND_HOMEPAGE_ONE_FAILD'

export const SIMSO_ORDER_SUCCESS = 'SIMSO:ORDER_SUCCESS'
export const SIMSO_ORDER_FAILD = 'SIMSO:ORDER_FAILD'

export const SIMSO_GET_SIM_ANALYSIS_SUCCESS = 'SIMSO:GET_SIM_ANALYSIS_SUCCESS'
export const SIMSO_GET_SIM_ANALYSIS_FAILD = 'SIMSO:GET_SIM_ANALYSIS_FAILD'

export const SimsoAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            SimsoService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: SIMSO_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: SIMSO_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { simso } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageSimsoFilter } = simso;
        const homepageSimsoPage = homepageSimsoFilter.homepageSimsoPage;
        const homepageSimsoLimit = homepageSimsoFilter.homepageSimsoLimit;

        return new Promise((resolve, reject) => {
            SimsoService.homepageList(homepageSimsoFilter).then((rs) => {
                if (!!homepageSimsoFilter && homepageSimsoFilter.homepageSimsoPage === 0) {
                    dispatch(success({
                        homepageSimsoItems: rs.data.values,
                        homepageSimsoTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = simso.homepageSimsoItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageSimsoLimit * homepageSimsoPage; i < homepageSimsoLimit * homepageSimsoPage + homepageSimsoLimit; i++) {
                        if (typeof rsDataValues[i - homepageSimsoLimit * homepageSimsoPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageSimsoLimit * homepageSimsoPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageSimsoItems: uniqueItems,
                        homepageSimsoTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMSO_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        SimsoService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: SIMSO_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      SimsoService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: SIMSO_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        SimsoService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { simso } = getState()
        dispatch(AppAction.appLoading(true));
        SimsoService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...simso.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            SimsoService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: SIMSO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            SimsoService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { simso } = getState();

            const { filter } = simso;

            // Perform your asynchronous operation (e.g., API call)
            SimsoService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: SIMSO_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { simso } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = simso;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            SimsoService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = simso.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMSO_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: SIMSO_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            SimsoService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(SimsoAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: SIMSO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_SAVE_FAILD, error } }
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        SimsoService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(SimsoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng số điện thoại!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        SimsoService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(SimsoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng số điện thoại!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        SimsoService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(SimsoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_DEL_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        SimsoService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        SimsoService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(SimsoAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { simso } = getState()
        dispatch(AppAction.appLoading(true));
        SimsoService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...simso.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        SimsoService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMSO_ORDER_SUCCESS, data } }
    function failure(error) { return { type: SIMSO_ORDER_FAILD, error } }
}